@if ((authService.userData$ | async) === null) {
  <button class="btn nav-link" type="button" (click)="login()">
    {{ 'common.login' | translate }}
  </button>
} @else {
  <ul class="navbar-nav">
    <li class="nav-item" dropdown>
      <a
        class="nav-link dropdown-toggle login-icon"
        dropdownToggle
        id="user-details-dropdown"
        role="button"
        aria-haspopup="true"
        [attr.aria-label]="'navigation.userMenu.aria.label' | translate"
      >
        <i
          class="fa fa-user-circle-o fa-5"
          style="font-size: x-large"
          aria-hidden="true"
        ></i>
      </a>
      <div
        *dropdownMenu
        class="dropdown-menu dropdown-menu-end"
        aria-labelledby="user-details-dropdown"
      >
        <span class="dropdown-header">{{
          (authService.userData$ | async).userdata.name
        }}</span>
        <a
          class="dropdown-item"
          routerLink="/omat-tiedot"
          routerLinkActive="active"
        >
          {{ 'navigation.login.userDetails' | translate }}
        </a>
        <button class="dropdown-item" type="button" (click)="logout()">
          {{ 'common.logout' | translate }}
        </button>
      </div>
    </li>
  </ul>
}
